module.exports = __webpack_public_path__ + "img/sort-descending.b65a9db2.svg";